import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { StorageService } from '../../../services/storage/storage.service';

export const afterLoginGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const storage = inject(StorageService);

  // Check if user is logged in by reading the signal value
  const loggedIn = auth.isLoggedIn();

  console.log('afterLoginGuard - isLoggedIn:', loggedIn, 'route:', state.url);

  if (loggedIn) {
    return true;
  } else {
    // Store the attempted URL for redirect after login
    if (state.url !== '/login') {
      storage.set('redirectUrl', state.url);
    }
    return router.navigateByUrl('/login', { replaceUrl: true });
  }
};

